import z from 'zod';
import { BusinessAuthorizationV2Schema } from './shared/create-default-business-roles';
import { BusinessAddressSchema, BusinessConfigurationsDefaultsSchema, BusinessFinancialDefaultsSchema, } from '../user/web';
export const BusinessDataV2Schema = z.object({
    id: z.string(),
    accountNumber: z.string().optional(),
    name: z.string(),
    // clientName: human-readable display name for the business
    isSuperAdmin: z.boolean(),
    businessInfo: z.object({
        address: BusinessAddressSchema,
        phone: z.string(),
        email: z.string().nullable(),
        website: z.string(),
        logoUrl: z.string().nullable(),
    }),
    financialDefaults: BusinessFinancialDefaultsSchema,
    configurations: BusinessConfigurationsDefaultsSchema,
    access_v2: BusinessAuthorizationV2Schema,
    // 4 digit pin number only
    system_pin: z
        .string()
        .length(4)
        .regex(/^\d{4}$/),
});
